import React from 'react';

import {SvgProps} from '../../helpers/type';

const File = ({className}: SvgProps): JSX.Element => {
    return (
        <svg
            width="46"
            height="46"
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect x="0.7125" y="0.7125" width="44.175" height="44.175" rx="9.42083" fill="#EDFCF2" fillOpacity="0.5" />
            <path
                d="M25.5072 12.8251H17.5272C16.43 12.8251 15.5422 13.7229 15.5422 14.8201L15.5322 30.7801C15.5322 31.8774 16.42 32.7751 17.5173 32.7751H29.4972C30.5945 32.7751 31.4922 31.8774 31.4922 30.7801V18.8101L25.5072 12.8251ZM26.5047 22.8001H22.5147V23.7976H25.5072C26.0559 23.7976 26.5047 24.2465 26.5047 24.7951V27.7876C26.5047 28.3362 26.0559 28.7851 25.5072 28.7851H24.5097V29.7826H22.5147V28.7851H20.5197V26.7901H24.5097V25.7926H21.5172C20.9686 25.7926 20.5197 25.3437 20.5197 24.7951V21.8026C20.5197 21.254 20.9686 20.8051 21.5172 20.8051H22.5147V19.8076H24.5097V20.8051H26.5047V22.8001ZM24.5097 18.8101V14.3214L28.9985 18.8101H24.5097Z"
                fill="#5D847F"
            />
            <rect
                x="0.7125"
                y="0.7125"
                width="44.175"
                height="44.175"
                rx="9.42083"
                stroke="#E8EDEC"
                strokeWidth="1.425"
            />
        </svg>
    );
};

export default File;
